import { Indicator } from '@/entities/indicator';
import React, { useState } from 'react';

interface IndicatorInterface{
    open: boolean,
    isEdit: boolean,
    deleteOpen:boolean,
    data2Edit: any
}

const IndicatorsContext = React.createContext<any>({} as IndicatorInterface);

export const IndicatorProvider: React.FC<any> = ({ children }) => {

  const [open, setOpen] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [ indexEdit, setIndexEdit] = useState(false);
  const [ data2Edit, setData2Edit ] = useState();
  const [ deleteOpen, setDeleteOpen ] = useState(false);

  return(
    <IndicatorsContext.Provider value={{open, isEdit, setOpen, setEdit, indexEdit, setIndexEdit, data2Edit, setData2Edit, deleteOpen, setDeleteOpen}}>{children}</IndicatorsContext.Provider>
  );

};

export const useIndicatorsContext = () => React.useContext(IndicatorsContext);
